<template>
  <div class="services">
    <h2 class="main-title container">Услуги</h2>
    <div class="services__all-items">
      <div class="services__all-items-empty-block is-left" />
      <div class="services__all-items-inner">
        <div class="services__item services-item">
          <h3 class="services-item__title">КОНЦЕПТ-ДИЗАЙН</h3>
          <p class="services-item__main-text">
            Услуга для тех, кто хочет получить чёткое визуальное видение будущего пространства — быстро и без лишних технических деталей. Идеально подходит, если вы хотите утвердить общую концепцию, прежде чем двигаться дальше, или планируете реализовывать проект самостоятельно / с собственной бригадой.
          </p>
          <p class="services-item__text">Что входит в концепт-дизайн?</p>
          <ul class="services-item__list services-list">
            <li>Обмерный план (составляется на основе размеров и планировки, предоставленных клиентом)</li>
            <li>Визуализация интерьера (фотореалистичные изображения по ключевым ракурсам)</li>
          </ul>
          <p class="services-item__annotation">
            Цена -&nbsp; <span>1500р</span>./м2
          </p>
          <AppButton theme="dark" @click="scrollToBlock('request-form')">
            Получить консультацию
          </AppButton>
        </div>
        <div class="services__item services-item">
          <h3 class="services-item__title">ДИЗАЙН-ПРОЕКТ</h3>
          <p class="services-item__main-text">
            Комплексное решение полного цикла — от идеи до готовой технической документации для строителей и ремонтной бригады. Вы получаете не просто «картинку», а исчерпывающий пакет документов, с которым можно приступать к реализации без дополнительных вопросов и простоев на объекте.
          </p>
          <p class="services-item__text">Что входит в дизайн-проект?</p>
          <ul class="services-item__list services-list">
            <li>Технический выезд на замер</li>
            <li>Обмерный план</li>
            <li>
              <div class="services-list__tooltip-wrapper">
                Архитектурно-отделочные чертежи
                <AppTooltip>
                  <template #content>
                    <span>План монтажа\демонтажа</span>
                    <span>План сантехники</span>
                    <span>План напольных покрытий</span>
                    <span>План теплого пола</span>
                    <span>План потолока</span>
                    <span>План дверей</span>
                    <span>План расстановки мебели</span>
                    <span>План электрики</span>
                    <span>План разверток</span>
                  </template>
                </AppTooltip>
              </div>
            </li>
            <li>Визуализации</li>
            <li>3D-тур</li>
          </ul>
          <p class="services-item__annotation">
            Цена -&nbsp; <span>2500р</span>./м2
          </p>
          <AppButton theme="dark" @click="scrollToBlock('request-form')">
            Получить консультацию
          </AppButton>
        </div>
      </div>
      <div class="services__all-items-empty-block is-right" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import AppButton from '@/components/ui/AppButton/Index.vue'
import AppTooltip from '@/components/ui/AppTooltip/Index.vue'

import useScrollToBlock from '@/features/useScrollToBlock'

export default defineComponent({
  name: 'Services',
  components: { AppButton, AppTooltip },
  setup() {
    return { ...useScrollToBlock() }
  },
})
</script>

<style lang="scss" scoped src="./Index.scss" />
